import axios from 'axios';
import {api} from '../utils/helper';

//****************** GET All Tables by Date for HE ******************//
export const exportHE = async (a) => {
    try{
     // const a = { orgID: sessionStorage.getItem('org'), projID: sessionStorage.getItem('project')}
    const resrep = await axios.post(
      `${api}/exportHE`, a,
      {
        headers: {
          authorization: sessionStorage.getItem('token'),
        },
      },
    );
//          console.log(`exportHE controller res: `, resrep);
          return resrep;
    }catch (error) {
//        console.log(`exportHE controller error: `, error?.response?.data);
        alert(error?.response?.data?.message);
    }

}